import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {MxField} from '../../services/mxField';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from "../../../../../../shared/services/mx-translate.service";

@Component({
    selector: 'mx-color-picker',
    standalone: false,
    templateUrl: './mx-color-picker.component.html',
    styleUrls: ['./mx-color-picker.component.scss']
})
export class MxColorPickerComponent extends MxField implements OnInit, OnDestroy {

    private _destroy$$: Subject<null> = new Subject<null>();

    @Input() defaultColor: string;

    private control: any;

    private initialColor: string;
    private presetColors: Array<string> = [
        '#E57373', '#CC2323', '#BA68C8',
        '#7986CB', '#4FC3F7', '#4DB6AC',
        '#81C784', '#FFF176', '#FFB74D',
        '#FF8A65', '#E0E0E0', '#90A4AE'];

    color: string;
    pickedColor: string;
    showResetButton: boolean = false;

    constructor(public errorService: MxFormErrorMessageService,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }

    ngOnInit(): void {
        if (this.fieldConfig && this.fieldConfig.showClearButton === true) {
            this.showResetButton = true;
        }

        this.control = this.form.controls[this.name];
        this.color = this.control.value || this.presetColors[Math.floor(Math.random() * 12)];
        this.pickedColor = this.color;
        this.initialColor = this.color;
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }

    changeColor(color: string): void {
        this.pickedColor = color;
    }

    selectColor(color: string) {
        this.control.setValue(color);
        this.changeFormState();
        this.color = color;
        this.pickedColor = color;
    }

    cancelColor() { }

    resetValueToDefault() {
        this.control.setValue(this.defaultColor);

        this.changeFormState();
        this.color = this.defaultColor;
        this.pickedColor = this.defaultColor;
    }

    changeFormState()  {
        if (this.control.value === this.initialColor) {
            this.control.markAsPristine();
            this.control.markAsUntouched();
        } else {
            this.control.markAsDirty();
            this.control.markAsTouched();
        }
    }
}
